import { render, staticRenderFns } from "./Crumps.vue?vue&type=template&id=c842f5d4"
import script from "./Crumps.vue?vue&type=script&lang=js"
export * from "./Crumps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports